import { render, staticRenderFns } from "./ReportImageWheelDetail.vue?vue&type=template&id=a6673f50"
import script from "./ReportImageWheelDetail.vue?vue&type=script&lang=ts"
export * from "./ReportImageWheelDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports